// extracted by mini-css-extract-plugin
module.exports = {"billingMenuItem":"BillingMenuItem_billingMenuItem__jzUYN","menuText":"BillingMenuItem_menuText__3orrn","isActive":"BillingMenuItem_isActive__1Jxfm"};